import { defineStore } from "pinia";
import api from "@/services/apiService";
// import { useRouter } from "vue-router";
import VueJwtDecode from "vue-jwt-decode";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("userData")) || null,
    token: localStorage.getItem("auth_token") || null,
    
  }),

  actions: {
    async login(email, password) {
      try {
        const response = await api.post("/login", { email, password });
    
        if (response.token) {
          // Save token first
          localStorage.setItem("auth_token", response.token);
          this.token = response.token;
    
          // Set Authorization header for the next request
          api.defaults.headers.common["Authorization"] = `Bearer ${response.token}`;
    
          // Fetch user info from /me
          const meRes = await api.get("/me");
          const userData = meRes.data;
    
          // Store user info in localStorage and Pinia
          localStorage.setItem("userData", JSON.stringify(userData));
          this.user = userData;
    
          return this.user;
        }
      } catch (error) {
        const errorMessage = error.response?.data?.error || "Invalid credentials";
        throw new Error(errorMessage);
      }
    }
    
    ,
    async register(fullName, email, password) {
      try {
        const response = await api.post("/register", { fullName, email, password });

        if (response.token) {
          const decodedToken = VueJwtDecode.decode(response.token);

          localStorage.setItem("auth_token", response.token);
          localStorage.setItem("userData", JSON.stringify(decodedToken));

          this.user = decodedToken;
          this.token = response.token;
          return decodedToken;
        }
      } catch (error) {
        throw new Error(error.response?.message || "Registration failed");
      }
    },
    logout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userData");
      this.user = null;
      this.token = null;
    
      
    }
    ,

    isTokenExpired() {
      if (!this.token) return true;

      try {
        const decodedToken = VueJwtDecode.decode(this.token);
        console.log("Token exp:", new Date(decodedToken.exp * 1000));

        const now = Math.floor(Date.now() / 1000);
        return now >= decodedToken.exp;
      } catch (error) {
        return true;
      }
    },
    

    autoLogoutIfTokenExpired() {
      if (this.isTokenExpired()) {
        this.logout();
      }
    },
    isAdmin() {
      return this.user?.roles?.includes("ROLE_ADMIN") || this.user?.roles?.includes("ROLE_AGENT");
    }
  },
});
